const GailIcon = ({ isBlue = false }: { isBlue?: boolean }) => {
  const fillColor = isBlue ? "#0062E2" : "#FFF";

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_678)">
        <path
          d="M11.5469 6.31611V12.372L17.5811 6.31611V0.260193L11.5469 6.31611Z"
          fill={fillColor}
        />
        <path
          d="M5.51486 12.372C3.85025 10.7014 3.85025 7.98669 5.51486 6.3161C6.35057 5.47738 7.44212 5.05973 8.53366 5.05973V0.780533C6.35057 0.780533 4.16407 1.61925 2.49947 3.28985C-0.833156 6.63447 -0.833156 12.0571 2.49947 15.4051C5.83209 18.7497 11.2352 18.7497 14.5713 15.4051L11.5525 12.3754C9.88786 14.046 7.18288 14.046 5.51827 12.3754L5.51486 12.372Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_678">
          <rect width="32" height="32" fill="#FFF" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GailIcon;
